'use strict';

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
require('core-js/modules/es.array.filter');
require('core-js/modules/es.object.values');
var RRule = _interopDefault(require('rrule'));
require('core-js/modules/es.array.concat');
var allowedHtmlTags = {
  allowedTags: ['b', 'i', 'em', 'strong', 'a', 'p', 'u', 'del', 'div', 'ins', 'li', 'ul', 'ol', 'br'],
  allowedAttributes: {
    a: ['href', 'target', 'rel']
  }
};
var avatarColours = {
  watusi: {
    backgroundColour: '#f5d0b9',
    textColour: '#845235'
  },
  hawkesBlue: {
    backgroundColour: '#f6dae4',
    textColour: '#8b4960'
  },
  botticelli: {
    backgroundColour: '#cedde9',
    textColour: '#46637d'
  },
  surfCrest: {
    backgroundColour: '#c8d8c2',
    textColour: '#49623f'
  },
  quarterSpanishWhite: {
    backgroundColour: '#e9e0d2',
    textColour: '#7a6114'
  },
  buttermilk: {
    backgroundColour: '#f1e0ab',
    textColour: '#635429'
  },
  fog: {
    backgroundColour: '#e0d8ee',
    textColour: '#625082'
  },
  mabel: {
    backgroundColour: '#c1e6e5',
    textColour: '#426968'
  }
};
var countries = {
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BA: "Bosnia and Herzegovina",
  BB: "Barbados",
  WF: "Wallis and Futuna",
  BL: "Saint Barthelemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BT: "Bhutan",
  JM: "Jamaica",
  BV: "Bouvet Island",
  BW: "Botswana",
  WS: "Samoa",
  BQ: "Bonaire, Saint Eustatius and Saba ",
  BR: "Brazil",
  BS: "Bahamas",
  JE: "Jersey",
  BY: "Belarus",
  BZ: "Belize",
  RU: "Russia",
  RW: "Rwanda",
  RS: "Serbia",
  TL: "East Timor",
  RE: "Reunion",
  TM: "Turkmenistan",
  TJ: "Tajikistan",
  RO: "Romania",
  TK: "Tokelau",
  GW: "Guinea-Bissau",
  GU: "Guam",
  GT: "Guatemala",
  GS: "South Georgia and the South Sandwich Islands",
  GR: "Greece",
  GQ: "Equatorial Guinea",
  GP: "Guadeloupe",
  JP: "Japan",
  GY: "Guyana",
  GG: "Guernsey",
  GF: "French Guiana",
  GE: "Georgia",
  GD: "Grenada",
  GB: "United Kingdom",
  GA: "Gabon",
  SV: "El Salvador",
  GN: "Guinea",
  GM: "Gambia",
  GL: "Greenland",
  GI: "Gibraltar",
  GH: "Ghana",
  OM: "Oman",
  TN: "Tunisia",
  JO: "Jordan",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  HK: "Hong Kong",
  HN: "Honduras",
  HM: "Heard Island and McDonald Islands",
  VE: "Venezuela",
  PR: "Puerto Rico",
  PS: "Palestinian Territory",
  PW: "Palau",
  PT: "Portugal",
  SJ: "Svalbard and Jan Mayen",
  PY: "Paraguay",
  IQ: "Iraq",
  PA: "Panama",
  PF: "French Polynesia",
  PG: "Papua New Guinea",
  PE: "Peru",
  PK: "Pakistan",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PM: "Saint Pierre and Miquelon",
  ZM: "Zambia",
  EH: "Western Sahara",
  EE: "Estonia",
  EG: "Egypt",
  ZA: "South Africa",
  EC: "Ecuador",
  IT: "Italy",
  VN: "Vietnam",
  SB: "Solomon Islands",
  ET: "Ethiopia",
  SO: "Somalia",
  ZW: "Zimbabwe",
  SA: "Saudi Arabia",
  ES: "Spain",
  ER: "Eritrea",
  ME: "Montenegro",
  MD: "Moldova",
  MG: "Madagascar",
  MF: "Saint Martin",
  MA: "Morocco",
  MC: "Monaco",
  UZ: "Uzbekistan",
  MM: "Myanmar",
  ML: "Mali",
  MO: "Macao",
  MN: "Mongolia",
  MH: "Marshall Islands",
  MK: "Macedonia",
  MU: "Mauritius",
  MT: "Malta",
  MW: "Malawi",
  MV: "Maldives",
  MQ: "Martinique",
  MP: "Northern Mariana Islands",
  MS: "Montserrat",
  MR: "Mauritania",
  IM: "Isle of Man",
  UG: "Uganda",
  TZ: "Tanzania",
  MY: "Malaysia",
  MX: "Mexico",
  IL: "Israel",
  FR: "France",
  IO: "British Indian Ocean Territory",
  SH: "Saint Helena",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  FM: "Micronesia",
  FO: "Faroe Islands",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NA: "Namibia",
  VU: "Vanuatu",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NZ: "New Zealand",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  CK: "Cook Islands",
  XK: "Kosovo",
  CI: "Ivory Coast",
  CH: "Switzerland",
  CO: "Colombia",
  CN: "China",
  CM: "Cameroon",
  CL: "Chile",
  CC: "Cocos Islands",
  CA: "Canada",
  CG: "Republic of the Congo",
  CF: "Central African Republic",
  CD: "Democratic Republic of the Congo",
  CZ: "Czech Republic",
  CY: "Cyprus",
  CX: "Christmas Island",
  CR: "Costa Rica",
  CW: "Curacao",
  CV: "Cape Verde",
  CU: "Cuba",
  SZ: "Swaziland",
  SY: "Syria",
  SX: "Sint Maarten",
  KG: "Kyrgyzstan",
  KE: "Kenya",
  SS: "South Sudan",
  SR: "Suriname",
  KI: "Kiribati",
  KH: "Cambodia",
  KN: "Saint Kitts and Nevis",
  KM: "Comoros",
  ST: "Sao Tome and Principe",
  SK: "Slovakia",
  KR: "South Korea",
  SI: "Slovenia",
  KP: "North Korea",
  KW: "Kuwait",
  SN: "Senegal",
  SM: "San Marino",
  SL: "Sierra Leone",
  SC: "Seychelles",
  KZ: "Kazakhstan",
  KY: "Cayman Islands",
  SG: "Singapore",
  SE: "Sweden",
  SD: "Sudan",
  DO: "Dominican Republic",
  DM: "Dominica",
  DJ: "Djibouti",
  DK: "Denmark",
  VG: "British Virgin Islands",
  DE: "Germany",
  YE: "Yemen",
  DZ: "Algeria",
  US: "United States",
  UY: "Uruguay",
  YT: "Mayotte",
  UM: "United States Minor Outlying Islands",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LA: "Laos",
  TV: "Tuvalu",
  TW: "Taiwan",
  TT: "Trinidad and Tobago",
  TR: "Turkey",
  LK: "Sri Lanka",
  LI: "Liechtenstein",
  LV: "Latvia",
  TO: "Tonga",
  LT: "Lithuania",
  LU: "Luxembourg",
  LR: "Liberia",
  LS: "Lesotho",
  TH: "Thailand",
  TF: "French Southern Territories",
  TG: "Togo",
  TD: "Chad",
  TC: "Turks and Caicos Islands",
  LY: "Libya",
  VA: "Vatican",
  VC: "Saint Vincent and the Grenadines",
  AE: "United Arab Emirates",
  AD: "Andorra",
  AG: "Antigua and Barbuda",
  AF: "Afghanistan",
  AI: "Anguilla",
  VI: "U.S. Virgin Islands",
  IS: "Iceland",
  IR: "Iran",
  AM: "Armenia",
  AL: "Albania",
  AO: "Angola",
  AQ: "Antarctica",
  AS: "American Samoa",
  AR: "Argentina",
  AU: "Australia",
  AT: "Austria",
  AW: "Aruba",
  IN: "India",
  AX: "Aland Islands",
  AZ: "Azerbaijan",
  IE: "Ireland",
  ID: "Indonesia",
  UA: "Ukraine",
  QA: "Qatar",
  MZ: "Mozambique"
};
var customFields = {
  maxMongoStringLength: 4096,
  // https://github.com/mongodb/mongo/blob/master/src/mongo/shell/linenoise.cpp#L145
  maxFileSizeBytes: 16000000,
  // 16 MB https://docs.mongodb.com/manual/reference/limits/
  emailReferenceHeadingString: 'Email (ref.)',
  uploadBatchSize: 25,
  fNameReferenceHeadingString: 'First name (ref.)',
  lNameReferenceHeadingString: 'Last name (ref.)',
  maxNumberOfRows: 501,
  // 500 rows + headings row
  templateFileName: 'Custom_Fields_Template.csv' // should end in .csv
};

var languages = ['abkhaz', 'afar', 'afrikaans', 'akan', 'albanian', 'amharic', 'arabic', 'aragonese', 'armenian', 'assamese', 'avaric', 'avestan', 'aymara', 'azerbaijani', 'bambara', 'bashkir', 'basque', 'belarusian', 'bengali', 'berber', 'bihari', 'bislama', 'bosnian', 'breton', 'bulgarian', 'burmese', 'cantonese', 'catalan', 'chamorro', 'chechen', 'chichewa', 'chinese (mandarin)', 'chuvash', 'cornish', 'corsican', 'cree', 'croatian', 'czech', 'danish', 'dari', 'divehi', 'dutch', 'dzongkha', 'english', 'esperanto', 'estonian', 'ewe', 'faroese', 'fijian', 'filipino', 'finnish', 'french', 'fula', 'gaelic', 'galician', 'ganda', 'georgian', 'german', 'greek', 'guaraní', 'gujarati', 'haitian', 'hausa', 'hebrew', 'herero', 'hindi', 'hiri motu', 'hungarian', 'icelandic', 'ido', 'igbo', 'indonesian', 'interlingua', 'interlingue', 'inuktitut', 'inupiaq', 'irish', 'italian', 'japanese', 'javanese', 'kalaallisut', 'kannada', 'kanuri', 'kashmiri', 'kazakh', 'khmer', 'kikuyu', 'kinyarwanda', 'kirundi', 'komi', 'kongo', 'korean', 'kurdish', 'kwanyama', 'kyrgyz', 'lao', 'latin', 'latvian', 'limburgish', 'lingala', 'lithuanian', 'luba-katanga', 'luxembourgish', 'macedonian', 'malagasy', 'malay', 'malayalam', 'maltese', 'manx', 'marathi (marāṭhī)', 'marshallese', 'mongolian', 'nauru', 'navajo', 'ndonga', 'nepali', 'northern ndebele', 'northern sami', 'northern sotho', 'norwegian bokmål', 'norwegian nynorsk', 'norwegian', 'nuosu', 'occitan', 'ojibwe', 'oriya', 'oromo', 'ossetian', 'panjabi', 'pashto', 'persian', 'polish', 'portuguese', 'pāli', 'quechua', 'romanian', 'romansh', 'russian', 'samoan', 'sango', 'sanskrit (saṁskṛta)', 'sardinian', 'scottish gaelic', 'serbian', 'shona', 'sign language', 'sindhi', 'sinhala', 'slovak', 'slovene', 'somali', 'southern ndebele', 'southern sotho', 'spanish', 'sundanese', 'swahili', 'swati', 'swedish', 'tagalog', 'tahitian', 'tajik', 'tamil', 'tatar', 'te reo māori', 'telugu', 'thai', 'tibetan standard', 'tigrinya', 'tonga', 'tsonga', 'tswana', 'turkish', 'turkmen', 'twi', 'ukrainian', 'urdu', 'uyghur', 'uzbek', 'venda', 'vietnamese', 'volapük', 'walloon', 'welsh', 'western frisian', 'wolof', 'xhosa', 'yiddish', 'yoruba', 'zhuang', 'zulu'];
var getSymbol = require('currency-symbol-map'); // ISO reference: https://www.currency-iso.org/en/home/tables/table-a1.html. This is what Intl.NumberFormat() uses.
// These are the currently supported currencies on our platform

var currencies = {
  AUD: {
    code: 'AUD',
    name: 'Australian Dollar',
    minorUnit: 2,
    // The number of digits after the decimal separator.
    symbol: getSymbol('AUD'),
    prefix: 'A' // To identify which currency when use the same symbol
  },

  NZD: {
    code: 'NZD',
    name: 'New Zealand Dollar',
    minorUnit: 2,
    symbol: getSymbol('NZD'),
    prefix: 'NZ'
  },
  GBP: {
    code: 'GBP',
    name: 'Pound Sterling',
    minorUnit: 2,
    symbol: getSymbol('GBP')
  },
  EUR: {
    code: 'EUR',
    name: 'Euro',
    minorUnit: 2,
    symbol: getSymbol('EUR')
  }
};
var distanceUnits = {
  km: {
    long: 'kilometers',
    short: 'km'
  },
  mi: {
    long: 'miles',
    short: 'mi'
  }
};
var groups = {
  maxNumberOfGroupMembers: 10000,
  defaultOptions: {
    details: ['Phone Number', 'Gender', 'Date of Birth', 'Home Address', 'Current Job Title', 'Emergency Contact Details'],
    requirements: ['Working with Children Check', 'Drivers License', 'Police Check', 'First Aid Certificate', 'Orientation', 'Training'],
    industries: ['Accommodations', 'Accounting', 'Advertising', 'Aerospace', 'Agriculture & Agribusiness', 'Air Transportation', 'Apparel & Accessories', 'Auto', 'Banking', 'Beauty & Cosmetics', 'Biotechnology', 'Chemical', 'Communications', 'Computer', 'Construction', 'Consulting', 'Consumer Products', 'Education', 'Electronics', 'Employment', 'Energy', 'Entertainment & Recreation', 'Fashion', 'Financial Services', 'Food & Beverage', 'Health', 'Information', 'Information Technology', 'Insurance', 'Journalism & News', 'Legal Services', 'Manufacturing', 'Media & Broadcasting', 'Medical Devices & Supplies', 'Motion Pictures & Video', 'Music', 'Pharmaceutical', 'Public Administration', 'Public Relations', 'Publishing', 'Real Estate', 'Retail', 'Service', 'Sports', 'Technology', 'Telecommunications', 'Tourism', 'Transportation', 'Travel', 'Utilities', 'Video Game', 'Web Services']
  },
  groupTypes: [{
    name: 'Business',
    value: 'business'
  }, {
    name: 'Charity/Not-for-profit',
    value: 'charity-not-for-profit'
  }, {
    name: 'Club/Community group',
    value: 'club-community-group'
  }, {
    name: 'Education provider',
    value: 'education-provider'
  }, {
    name: 'Government/Public sector',
    value: 'government-public-sector'
  }, {
    name: 'Volunteer services & centre',
    value: 'volunteer-service-centre'
  }]
};
var insuranceStatuses = {
  INSURED: {
    value: 'insured',
    label: 'We have insurance'
  },
  UNINSURED: {
    value: 'uninsured',
    label: 'We don\'t have insurance'
  },
  AUSPICED: {
    value: 'auspiced',
    label: 'We are auspiced by another organisation'
  }
};
var insuranceTypes = {
  publicLiabilityAU: {
    type: 'publicLiabilityAU',
    label: 'Public Liability Insurance'
  },
  volunteerAccidentAU: {
    type: 'volunteerAccidentAU',
    label: 'Volunteer Accident Insurance'
  },
  publicLiabilityGB: {
    type: 'publicLiabilityGB',
    label: 'Public Liability'
  },
  volunteerAccidentGB: {
    type: 'volunteerAccidentGB',
    label: 'Employer\'s Liability'
  },
  publicLiabilityNZ: {
    type: 'publicLiabilityNZ',
    label: 'Public Liability'
  },
  volunteerAccidentNZ: {
    type: 'volunteerAccidentNZ',
    label: 'Employer\'s Liability'
  },
  publicLiabilityOthers: {
    type: 'publicLiabilityOthers',
    label: 'Public Liability'
  },
  volunteerAccidentOthers: {
    type: 'volunteerAccidentOthers',
    label: 'Employer\'s Liability'
  }
};
var locales = {
  europeanCountryCodes: ['AL', 'AD', 'AM', 'AT', 'BY', 'BE', 'BA', 'BG', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FO', 'FI', 'FR', 'GE', 'VA', 'GI', 'GR', 'HU', 'HR', 'IE', 'IS', 'IT', 'LT', 'LU', 'LV', 'MC', 'MK', 'MT', 'NO', 'NL', 'PO', 'PT', 'RO', 'RU', 'SE', 'SI', 'SK', 'SM', 'TR', 'UA'],
  regionOptions: {
    au: {
      name: 'Australia',
      domain: 'https://app.becollective.com',
      hostname: 'app.becollective.com',
      trademark: 'Be Collective International Limited',
      twitter: 'https://twitter.com/BeCollective_',
      facebook: 'https://www.facebook.com/becollectiveintl/',
      instagram: 'https://www.instagram.com/becollective_',
      linkedin: 'https://www.linkedin.com/company/becollectiveintl',
      privacyPolicyUrl: 'https://app.becollective.com/assets/landing/au/assets/documents/Be-Collective-Global-Privacy-Policy-September-2021.pdf',
      termsAndConditionsUrl: 'https://app.becollective.com/assets/landing/au/assets/documents/Be-Collective-Global-General-Terms-September-2022.pdf',
      privacyPolicyVersion: 2,
      termsAndConditionsVersion: 5,
      address: '28 Thistlethwaite Street, South Melbourne, VIC 3205'
    },
    nz: {
      name: 'New Zealand',
      domain: 'https://nz.becollective.com',
      hostname: 'nz.becollective.com',
      trademark: 'Be Collective New Zealand Limited',
      twitter: 'https://twitter.com/BeCollective_',
      facebook: 'https://www.facebook.com/becollectivenz/',
      instagram: 'https://www.instagram.com/becollective_',
      linkedin: 'https://www.linkedin.com/company/becollectiveintl',
      privacyPolicyUrl: 'https://nz.becollective.com/assets/landing/nz/assets/documents/Be-Collective-Global-Privacy-Policy-September-2021.pdf',
      termsAndConditionsUrl: 'https://nz.becollective.com/assets/landing/nz/assets/documents/Be-Collective-Global-General-Terms-September-2022.pdf',
      privacyPolicyVersion: 2,
      termsAndConditionsVersion: 5,
      address: 'Level 3 Zephyr House, 82 Willis Street, Wellington'
    },
    eu: {
      name: 'Europe',
      domain: 'https://eu.becollective.com',
      hostname: 'eu.becollective.com',
      trademark: 'Be Collective Europe Limited',
      twitter: 'https://twitter.com/BeCollective_',
      facebook: 'https://www.facebook.com/Be-Collective-Europe-2168455776525016/',
      instagram: 'https://www.instagram.com/becollective_',
      linkedin: 'https://www.linkedin.com/company/becollectiveintl',
      privacyPolicyUrl: 'https://eu.becollective.com/assets/landing/eu/assets/documents/Be-Collective-Europe-Privacy-Notice-December-2020.pdf',
      termsAndConditionsUrl: 'https://eu.becollective.com/assets/landing/eu/assets/documents/Be-Collective-Europe-Terms-and-Conditions-July-2019.pdf',
      privacyPolicyVersion: 2,
      termsAndConditionsVersion: 2,
      address: 'Tintagel House, 92 Albert Embankment, Lambeth, London, SE1 7TY'
    },
    uk: {
      name: 'United Kingdom',
      domain: 'https://uk.becollective.com',
      hostname: 'uk.becollective.com',
      trademark: 'Be Collective Europe Limited',
      twitter: 'https://twitter.com/BeCollective_',
      facebook: 'https://www.facebook.com/Be-Collective-Europe-2168455776525016/',
      instagram: 'https://www.instagram.com/becollective_',
      linkedin: 'https://www.linkedin.com/company/becollectiveintl',
      privacyPolicyUrl: 'https://uk.becollective.com/assets/landing/uk/assets/documents/Be-Collective-Europe-Privacy-Notice-December-2020.pdf',
      termsAndConditionsUrl: 'https://uk.becollective.com/assets/landing/uk/assets/documents/Be-Collective-Europe-Terms-and-Conditions-July-2019.pdf',
      privacyPolicyVersion: 2,
      termsAndConditionsVersion: 2,
      address: 'Tintagel House, 92 Albert Embankment, Lambeth, London, SE1 7TY'
    }
  },
  // Financial years from https://www.cia.gov/library/publications/the-world-factbook/fields/228.html
  countryOptions: {
    AU: {
      financialYearEndDate: {
        month: 5,
        date: 30
      },
      distanceUnit: distanceUnits.km,
      regions: [{
        long: 'Australian Capital Territory',
        short: 'ACT'
      }, {
        long: 'New South Wales',
        short: 'NSW'
      }, {
        long: 'Northern Territory',
        short: 'NT'
      }, {
        long: 'Queensland',
        short: 'QLD'
      }, {
        long: 'South Australia',
        short: 'SA'
      }, {
        long: 'Tasmania',
        short: 'TAS'
      }, {
        long: 'Victoria',
        short: 'VIC'
      }, {
        long: 'Western Australia',
        short: 'WA'
      }],
      insuranceTypes: [insuranceTypes.publicLiabilityAU, insuranceTypes.volunteerAccidentAU]
    },
    NZ: {
      financialYearEndDate: {
        month: 2,
        date: 31
      },
      distanceUnit: distanceUnits.km,
      insuranceTypes: [insuranceTypes.publicLiabilityNZ, insuranceTypes.volunteerAccidentNZ]
    },
    GB: {
      financialYearEndDate: {
        month: 3,
        date: 5
      },
      distanceUnit: distanceUnits.mi,
      insuranceTypes: [insuranceTypes.publicLiabilityGB, insuranceTypes.volunteerAccidentGB]
    },
    // Reminder: this is Republic of Ireland. Northern Ireland is within GB.
    IE: {
      financialYearEndDate: {
        month: 11,
        date: 31
      },
      distanceUnit: distanceUnits.km,
      insuranceTypes: [insuranceTypes.publicLiabilityOthers, insuranceTypes.volunteerAccidentOthers]
    },
    Others: {
      insuranceTypes: [insuranceTypes.publicLiabilityOthers, insuranceTypes.volunteerAccidentOthers]
    }
  }
};
var notificationTypes = {
  volunteer: {
    messengerUpdates: 'messengerUpdates',
    volunteerUpdates: 'volunteerUpdates',
    groupMemberUpdates: 'groupMemberUpdates',
    groupInvitations: 'groupInvitations',
    opportunityInvitations: 'opportunityInvitations',
    opportunitiesSharedWithMe: 'opportunitiesSharedWithMe',
    licenseCertificateExpiryNotice: 'licenseCertificateExpiryNotice',
    certificates: 'certificates'
  },
  manager: {
    membershipApplications: 'membershipApplications',
    volunteerApplications: 'volunteerApplications',
    opportunityUpdates: 'opportunityUpdates',
    timesheets: 'timesheets',
    partnerships: 'partnerships',
    endorsements: 'endorsements',
    socialCurrency: 'socialCurrency',
    groupUpdates: 'groupUpdates',
    licenseCertificateExpiryNotice: 'licenseCertificateExpiryNotice'
  },
  acquired: 'acquired'
};
var notifications = {
  // Filter out acquired, as backend model does not use it.
  types: Object.values(notificationTypes).filter(function (x) {
    return x !== notificationTypes.acquired;
  }),
  typesMap: notificationTypes
};
var typesMap = {
  roleFixed: 'role-fixed',
  roleFlexible: 'role-flexible',
  ongoing: 'ongoing'
};
var typesMapV2 = {
  shift: 'shift',
  flexible: 'flexible'
};
var ruleStatus = {
  approved: 'approved',
  cancelled: 'cancelled'
};
var shiftStatus = {
  approved: 'approved',
  cancelled: 'cancelled',
  left: 'left'
};
var volunteerStatus = {
  approved: "approved",
  pending: "pending",
  invited: "invited",
  declined: "declined",
  left: "left"
};
var opportunities = {
  types: Object.values(typesMap),
  typesMap: typesMap,
  typesV2: Object.values(typesMapV2),
  typesMapV2: typesMapV2,
  statuses: ['draft', 'pending', 'published', 'cancelled'],
  volunteer: {
    shiftStatus: shiftStatus,
    ruleStatus: ruleStatus,
    volunteerStatus: volunteerStatus
  },
  checklist: [{
    key: 'interview',
    value: 'Interview'
  }, {
    key: 'police-check',
    value: 'Police Check'
  }, {
    key: 'reference-check',
    value: 'Reference Check'
  }, {
    key: 'screening',
    value: 'Screening'
  }, {
    key: 'training',
    value: 'Training'
  }, {
    key: 'trial',
    value: 'Check'
  }],
  defaultOptions: {
    details: {
      currentJobTitle: 'Current Job Title',
      dateOfBirth: 'Date of Birth',
      emergencyContactDetails: 'Emergency Contact Details',
      gender: 'Gender',
      homeAddress: 'Home Address',
      phoneNumber: 'Phone Number'
    },
    requirements: {
      driversLicense: 'Drivers License',
      firstAidCertificate: 'First Aid Certificate',
      orientation: 'Orientation',
      policeCheck: 'Police Check',
      training: 'Training',
      workingWithChildrenCheck: 'Working with Children Check'
    },
    suitability: {
      families: 'Families',
      hearingImpaired: 'Hearing impaired',
      intellectuallyDisabled: 'Intellectual/Learning Disabilities',
      largeGroups: 'Large groups (10+)',
      skilledVolunteer: 'Skilled Volunteer',
      travellingShortTermVolunteers: 'Travelling/Short term volunteers',
      visionImpaired: 'Vision impaired',
      volunteersWithlimitedEnglish: 'Volunteers with limited English',
      wheelchairUsers: 'Wheelchair users',
      workingExperience: 'Work Experience'
    }
  }
};
var daysOfTheWeek = [{
  label: 'Monday',
  value: RRule.MO,
  selected: false
}, {
  label: 'Tuesday',
  value: RRule.TU,
  selected: false
}, {
  label: 'Wednesday',
  value: RRule.WE,
  selected: false
}, {
  label: 'Thursday',
  value: RRule.TH,
  selected: false
}, {
  label: 'Friday',
  value: RRule.FR,
  selected: false
}, {
  label: 'Saturday',
  value: RRule.SA,
  selected: false
}, {
  label: 'Sunday',
  value: RRule.SU,
  selected: false
}];
var frequencyOptions = [{
  value: 0,
  label: 'in total',
  description: ''
}, {
  value: RRule.WEEKLY,
  label: 'per week',
  description: 'each week'
}, {
  value: RRule.MONTHLY,
  label: 'per month',
  description: 'each month'
}];
var rules = {
  daysOfTheWeek: daysOfTheWeek,
  frequencyOptions: frequencyOptions
};
var subscriptions = {
  tierValues: {
    none: 0,
    // none of the below tiers
    standard: 1,
    plus: 2,
    pro: 3
  }
};
var surveys = {
  participantStatuses: {
    notSent: 'not-sent',
    sent: 'sent',
    reSent: 're-sent',
    responded: 'responded'
  },
  subscriptionDowngradeReasons: {
    featureLack: 'Features not useful / missing features we need',
    expense: 'Too expensive',
    difficulty: 'Difficult to use',
    technicalIssues: 'Technical issues',
    other: 'Other'
  }
};
var licencesAndCertifications = ['Drivers Licence', 'First Aid Certification', 'Working with Children Check', 'Other'];
var educationalQualifications = ['Secondary / High School', 'Certificate or equivalent', 'Diploma or equivalent', 'Advanced Diploma or equivalent', "Bachelor's Degree / Undergraduate", "Master's Degree / Postgraduate and above"];
var qualificationTypes = [].concat(licencesAndCertifications, educationalQualifications);
module.exports = {
  allowedHtmlTags: allowedHtmlTags,
  avatarColours: avatarColours,
  currencies: currencies,
  customFields: customFields,
  countries: countries,
  languages: languages,
  distanceUnits: distanceUnits,
  groups: groups,
  insuranceStatuses: insuranceStatuses,
  insuranceTypes: insuranceTypes,
  locales: locales,
  notifications: notifications,
  opportunities: opportunities,
  qualificationTypes: qualificationTypes,
  licencesAndCertifications: licencesAndCertifications,
  educationalQualifications: educationalQualifications,
  surveys: surveys,
  subscriptions: subscriptions,
  rules: rules
};